/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImpersonateUserParams { 
    /**
     * The reason for impersonating the user.
     */
    reason: ImpersonateUserParams.ReasonEnum;
    /**
     * Additional details about the reason for impersonation, reqired if reason is \'other\'.
     */
    reason_details?: string;
}
export namespace ImpersonateUserParams {
    export type ReasonEnum = 'troubleshooting' | 'onboarding_setup' | 'verify_permissions' | 'other';
    export const ReasonEnum = {
        TROUBLESHOOTING: 'troubleshooting' as ReasonEnum,
        ONBOARDING_SETUP: 'onboarding_setup' as ReasonEnum,
        VERIFY_PERMISSIONS: 'verify_permissions' as ReasonEnum,
        OTHER: 'other' as ReasonEnum
    };
}


